import React, { Component } from 'react'
import PropTypes from 'prop-types';
import { Hidden, Drawer, CssBaseline } from '@material-ui/core';

import './styles.css';
import ViewerRoutes from '../ViewerRoutes';
import Menu from '../Menu';
import AppBar from '../AppBar'
import { Notifications } from '../../../modules/notification';

import View from 'react-flexbox'
class Layout extends Component {

    constructor(props) {
        super(props);
        this.state = {
            mobileOpen: false,
        };
    }

    render() {
        const { classes, theme, user, ...otherProps } = this.props;
        const drawer = (
            <Menu  {...otherProps} />

        );
        const drawerMobile = (
            <Menu onClick={() => {
                this.setState(state => ({ mobileOpen: !state.mobileOpen }));
            }} {...otherProps} />

        );

        return (
            <div className={classes.root}>

                <CssBaseline />
                {user &&
                    <AppBar onClickMenu={() => {
                        this.setState(state => ({ mobileOpen: !state.mobileOpen }));
                    }} {...this.props} />
                }
                {user &&
                    <nav className={classes.drawer}>

                        <Hidden smUp implementation="css">
                            <Drawer
                                container={this.props.container}
                                variant="temporary"
                                anchor={theme.direction === 'rtl' ? 'right' : 'left'}
                                open={this.state.mobileOpen}
                                onClose={() => {
                                    this.setState(state => ({ mobileOpen: !state.mobileOpen }));
                                }}
                                classes={{
                                    paper: classes.drawerPaper,
                                }}
                                ModalProps={{
                                    keepMounted: true, // Better open performance on mobile.
                                }}
                            >
                                {drawerMobile}
                            </Drawer>
                        </Hidden>
                        <Hidden xsDown implementation="css">
                            <Drawer
                                classes={{
                                    paper: classes.drawerPaper,
                                }}
                                variant="permanent"
                                open
                            >
                                {drawer}
                            </Drawer>
                        </Hidden>
                    </nav>
                }
                <main className={classes.content}>
                    <View column style={{height: '100%'}}>
                        {user &&
                            // <div className={classes.toolbar} />
                            <View column className={classes.toolbar} style={{ flex: 0 }} />

                        }
                        <ViewerRoutes {...this.props} />
                    </View>
                </main>
                <Notifications />

            </div>
        );
    }
}

Layout.propTypes = {
    classes: PropTypes.object.isRequired,
    container: PropTypes.object,
    theme: PropTypes.object.isRequired,
};
export default Layout


// WEBPACK FOOTER //
// ./src/App/components/Layout/Layout.js